import * as R from 'ramda'
import P from 'helpers/predicates'

const getDate = (text) => {
  return text.split('').reduce((result, value, index, array) => {
    if (index % 2 === 0 )
      result.push(array.slice(index, index + 2).join(''))
    return result
  }, []).join('/')
}

const noValidation = [
  [(val) => false, '']
]

const isValidDate = R.compose(
  R.not,
  isNaN,
  Date.parse,
  getDate
)

const isNotNull = [
  [P.isNotEmptyString, 'Input cannot be empty.'],
  [P.isNotNil, 'Input cannot be empty.']
]

const isValidHex = R.allPass([
  R.startsWith('0x'),
  R.compose(
    P.isHex,
    R.slice(2, Infinity)
  ),
])

const isHexId = [
  ...isNotNull,
  [isValidHex, 'Input must be a valid (ex. 0x10de)'],
  [R.complement(P.isUppercase), 'Input must be lowercase'],
  [R.propEq('length', 6), 'Character length is invalid']
]

const isObjectValuesEmpty = R.compose(
  R.not,
  R.any(R.anyPass([
    R.isNil,
    R.isEmpty,
  ])),
  R.values
)

const isWithinRange = (range, allowNull) => {
  let whichRange = range.split('-')
  let rangeType = whichRange.indexOf('')
  // check for existence as well
  let validations = []

  // if field is allowed to be null, add to the rules
  if (!allowNull) {
    switch(rangeType) {
      case 0:
        // this means the - is before the number. The range is all numbers less than
        validations.push([
          P.isLessThan(parseFloat(whichRange[1])), `Must be less than ${whichRange[1]}`
        ])
        break
      case 1:
        // this means the - is after the number. Range is all numbers greater than
        validations.push([
          P.isGreaterThan(parseFloat(whichRange[0])), `Must be greater than ${whichRange[0]}`
        ])
        break
      default:
        // range is normal
        validations.push([
          P.between(parseFloat(whichRange[0]), parseFloat(whichRange[1])), `Must be between ${whichRange[0]} and ${whichRange[1]}`
        ])
    }

  } else {
    switch(rangeType) {
      case 0:
        validations.push([
          P.isLessThanOrNil(parseFloat(whichRange[1])), `Must be less than ${whichRange[1]}`
        ])
        break
      case 1:
        validations.push([
          P.isGreaterThanOrNil(parseFloat(whichRange[0])), `Must be greater than ${whichRange[0]}`
        ])
        break
      default:
        validations.push([
          P.betweenOrNil(parseFloat(whichRange[0]), parseFloat(whichRange[1])), `Must be between ${whichRange[0]} and ${whichRange[1]}`
        ])
    }
  }

  
  return validations
}

const isObjectEmpty = [
  [isObjectValuesEmpty, 'Values cannot be empty.']
]

const isDate = [
  [R.propEq('length', 6), 'Character length is invalid.'],
  [isValidDate, 'Input must be a valid date.']
]

export {
  isObjectEmpty,
  isNotNull,
  isHexId,
  isDate,
  isWithinRange,
  noValidation
}
